<template>
  <section class="ni-section ni-ask" id="qd-service">
    <div class="ni-container">
      <SectionHeader
        variant="dark"
        :subtitle="lang === 'zh' ? 'ASK ABOUT THE QINGDAO SERVICE PLATFORM' : 'ASK ABOUT THE QINGDAO SERVICE PLATFORM'"
        :lang="lang"
      >
        <template #title>
          <span class="ni-section-header__title-mark">
            {{ lang === 'zh' ? '问青岛服务平台' : 'Services Hub' }}
          </span>
        </template>
      </SectionHeader>

      <div class="ni-ask__grid">
        <a
          v-for="srv in serviceItems"
          :key="srv.id"
          :id="`service-card-${srv.id}`"
          class="ni-ask__card"
          :href="srv.redirectUrl"
          target="_blank"
          rel="noopener noreferrer"
          :title="srv.title"
        >
          <div class="ni-ask__card-icon">
            <img :src="getServiceIcon(srv.id)" :alt="srv.title" class="ni-ask__card-icon-img" />
          </div>
          <div class="ni-ask__card-text">
            <div
              v-for="(line, lineIdx) in getCardTextLines(srv.id, lang)"
              :key="lineIdx"
              :class="lineIdx === 0 ? 'ni-ask__card-line1' : 'ni-ask__card-line2'"
            >
              {{ line }}
            </div>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { serviceItems } from '@/data/newIndexMock.js';
import { getServiceIcon } from '@/data/newIndexAssets.js';
import SectionHeader from './shared/SectionHeader.vue';

defineProps({
  lang: {
    type: String,
    default: 'zh',
    validator: (value) => ['zh', 'en'].includes(value)
  }
});

const CARD_TEXT_LINES = {
  zh: {
    'srv-1': ['12366税务服务。', '在线咨询'],
    'srv-2': ['海外人员', '居住登记'],
    'srv-3': ['在线查看外国人。', '申请状态'],
    'srv-4': ['进展查询', '关于外国人的作品', '中国的许可。'],
    'srv-5': ['首次申请', '居住', '学生许可'],
    'srv-6': ['扩展', '居留许可', '(外国人)'],
    'srv-7': ['护照更改', '不。(居留许可)', '(外国人)'],
    'srv-8': ['地址变更', '居留许可 (外国)', '全国购)']
  },
  en: {
    'srv-1': ['12366 Tax Service.', 'Online Consultation'],
    'srv-2': ['Foreign Residents', 'Residency Registry'],
    'srv-3': ['Check Foreigners Online.', 'Application Status'],
    'srv-4': ['Progress Query', 'Foreign Works', 'Chinese Permit.'],
    'srv-5': ['First Application', 'Residency', 'Student Permit'],
    'srv-6': ['Extension', 'Residency Permit', '(Foreigner)'],
    'srv-7': ['Passport Update', 'No. (Residency Permit)', '(Foreigner)'],
    'srv-8': ['Address Update', 'Residency Permit (Foreign)', 'Nationwide Purchase)']
  }
};

function getCardTextLines(id, lang) {
  const dict = CARD_TEXT_LINES[lang === 'en' ? 'en' : 'zh'];
  return dict[id] || [];
}
</script>
